import { useContext } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Box, Button } from '@mui/material'

import { SiteRouter, PresentationRouter } from './routers'
import { AuthContext } from './providers'
import { PresentationContainer, LoginContainer } from './containers'
import { gtag } from './_utilities/ga4'

const { REACT_PUBLIC_URL } = process.env

export const About = () => <div>About Content</div>

const ProtectedRoutes = () => {
  return (
    <Routes>
      <Route path="/about" element={<About />} />
      <Route path="*" element={<Navigate to="/about" replace />} />
      {/* <Route path="/symptom-guide" element={<SymptomGuideContainer />} /> */}
    </Routes>
  )
}
interface GA4Props {
  p?: any
}
const GA4: React.FC<GA4Props> = ({ p }) => {
  gtag('event', 'test', { location: 'Pres' })
  return (
    <Box>
      <Button
        onClick={() => {
          gtag('event', 'click', { location: 'Pres' })
          alert('here')
        }}
      >
        click
      </Button>
      ga
    </Box>
  )
}

const OpenRoutes = () => {
  return (
    <Routes>
      <Route path="/ga" element={<GA4 />} />
      <Route path="/about" element={<About />} />
      <Route path="/site" element={<SiteRouter />}>
        <Route
          path="/site/:sourceSite/presentations"
          element={<PresentationRouter />}
        >
          <Route
            path="/site/:sourceSite/presentations/:presentationId"
            element={<PresentationContainer />}
          />
        </Route>
      </Route>
      <Route path="*" element={<LoginContainer />} />
    </Routes>
  )
}
const AppRouter: React.FC = () => {
  const { auth } = useContext(AuthContext)

  return (
    <Box
      className="AppRouter"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <BrowserRouter basename={REACT_PUBLIC_URL}>
        {auth?.isSignedIn ? <ProtectedRoutes /> : <OpenRoutes />}
      </BrowserRouter>
    </Box>
  )
}

export default AppRouter
